import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import "./App.css";

/* FRONTEND */
import MainLayout from "./layout/Mainlayout";
import Home from "./pages/Home";
import GamesPage from "./pages/GamesPage";
import TrailerPage from "./pages/TrailerPage";
import TermsOfService from "./pages/TermsOfService";
import Blog from "./pages/Blog";
import VideoPage from "./pages/VideoPage";
import MyAccount from "./pages/MyAccount";
import Wallet from "./pages/Wallet";
import LeaderboardPage from "./pages/LeaderboardPage";
import Play from "./pages/Play";
import NotFound from "./pages/NotFound";
import Support  from "./pages/Support";
import Tournament from "pages/Tournament";
import Gameiosign from "pages/auth/Gameiosign";

/* ðŸ”¥ ADMIN â€“ LAZY LOADED */
const Admin = lazy(() => import("./admin/Admin"));

const pageTitles = {
  "/": "Home",
  "/games": "Games",
  "/play": "Play Games",
  "/news": "News",
  "/terms-of-service": "Terms of Service",
  "/blog": "Blog",
  "/video": "Videos",
  "/support": "Support",
  "/tournament": "Tournaments",
  "/myaccount": "My Account",
  "/wallet": "Wallet",
  "/leaderboard": "Leaderboard",
  "/gameiosign": "Sign In",
};
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);

    const normalizedPath = pathname.toLowerCase().replace(/\/$/, "") || "/";
    if (!normalizedPath.startsWith("/admin")) {
      const pageName = pageTitles[normalizedPath] || "Page Not Found";
      document.title = `${pageName} | The Gameio`;
    }
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
       
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="games" element={<GamesPage />} />
          <Route path="play" element={<Play />} />
          <Route path="news" element={<TrailerPage />} />
          <Route path="signin" element={<Navigate to="/games" replace />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="blog" element={<Blog />} />
          <Route path="video" element={<VideoPage />} />
          <Route path="support" element={<Support />} />
          <Route path="Tournament" element={<Tournament />} />
          <Route path="myaccount" element={<MyAccount />} />
          <Route path="wallet" element={<Wallet />} />
          <Route path="leaderboard" element={<LeaderboardPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>

         <Route path="Gameiosign" element={<Gameiosign />} />
        
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div>Loading admin...</div>}>
              <Admin />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
